import { ApolloProvider } from '@apollo/client';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { Store as ReduxStore, Persistor } from 'Redux/Config';
import { PersistGate } from 'redux-persist/integration/react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { environment } from 'utils/environment';
import public_keys from 'public_keys';
import { VERSION } from './config';
import { themeSleep, ThemeProvider } from 'View/Theme';
import { RouteDataProvider, Router, TExtendedRoute } from 'View/Application';
import { apolloClient } from 'utils/RequestApi';
import { Footer } from 'View/Component';
import { ScrollToTop } from 'utils/scrollToTop';

// TODO: use process.env once the website can reference env vars at runtime
if (['staging', 'production'].includes(environment)) {
  try {
    Bugsnag.start({
      apiKey: public_keys.BUGSNAG_KEY_WEBSITE ?? '',
      plugins: [new BugsnagPluginReact()],
      releaseStage: environment,
      appVersion: VERSION,
    });
  } catch (error) {
    console.error(error);
  }
}

export const App = () => {
  const [currentRoute, setCurrentRoute] = useState<null | TExtendedRoute>(null);

  useEffect(() => {
    if (!window.dataLayer) {
      const { href, origin, pathname } = window.location;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Pageview-React',
        pagePath: { href, origin, pathname },
      });
    }
  }, []);

  // ToDo
  // useEffect(() => {
  //   if (navigationType === 'PUSH') {
  //     window.dataLayer?.push({
  //       event: 'Pageview-React',
  //       pagePath: {
  //         href: window.location.href,
  //         origin: window.location.origin,
  //         // pathname: location.pathname,
  //       },
  //     });
  //   }
  // }, [navigationType]);

  return (
    <ApolloProvider client={apolloClient}>
      <Provider store={ReduxStore}>
        <PersistGate persistor={Persistor} loading={null}>
          <ThemeProvider theme={themeSleep}>
            <RouteDataProvider value={{ currentRoute, setCurrentRoute }}>
              <Router>
                <ScrollToTop />
                <Footer />
              </Router>
            </RouteDataProvider>
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </ApolloProvider>
  );
};
